"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SalesForceReflectType;
(function (SalesForceReflectType) {
    SalesForceReflectType.TORIHIKISAKI = 'torihikisaki';
    SalesForceReflectType.TORIHIKISAKI_CORPORATE = 'torihikisaki_corporate';
    SalesForceReflectType.SEKININSYA_APPLY = 'torihikisaki_apply';
    SalesForceReflectType.SEKININSYA_TANTO = 'torihikisaki_tanto';
    SalesForceReflectType.OPPORTUNITY = 'opportunity';
    SalesForceReflectType.OPPORTUNITY_AFTER = 'opportunity_after';
    SalesForceReflectType.OPPORTUNITY_KOBETU = 'opportunity_kobetu';
    SalesForceReflectType.OPPORTUNITY_KOBETU_FREE = 'opportunity_kobetu_free';
    SalesForceReflectType.OPPORTUNITY_KOBETU_PRE = 'opportunity_kobetu_pre';
    SalesForceReflectType.OPPORTUNITY_ITEM_KOBETU = 'opportunity_item_kobetu';
    SalesForceReflectType.OPPORTUNITY_ITEM_KOBETU_FREE = 'opportunity_item_kobetu_free';
    SalesForceReflectType.OPPORTUNITY_ORAL_CARE = 'opportunity_oral_care';
    SalesForceReflectType.OPPORTUNITY_ORAL_CARE_FREE = 'opportunity_oral_care_free';
    SalesForceReflectType.OPPORTUNITY_ORAL_CARE_PRE = 'opportunity_oral_care_pre';
    SalesForceReflectType.OPPORTUNITY_ITEM_ORAL_CARE = 'opportunity_item_oral_care';
    SalesForceReflectType.OPPORTUNITY_ITEM_ORAL_CARE_FREE = 'opportunity_item_oral_care_free';
    SalesForceReflectType.OPPORTUNITY_ITEM_INPUT_AGENCY = 'opportunity_item_input_agency';
    SalesForceReflectType.OPPORTUNITY_ITEM_INPUT_AGENCY_PRE = 'opportunity_item_input_agency_pre';
    SalesForceReflectType.OPPORTUNITY_ITEM_UPGRADE = 'opportunity_item_upgrade';
    SalesForceReflectType.OPPORTUNITY_ITEM_BASIC = 'opportunity_item_basic';
    SalesForceReflectType.OPPORTUNITY_ITEM_ENTRY = 'opportunity_item_entry';
    SalesForceReflectType.OPPORTUNITY_ITEM_OLD_STANDARD = 'opportunity_item_old_standard';
    SalesForceReflectType.OPPORTUNITY_ITEM_MEDIUM = 'opportunity_item_medium';
    SalesForceReflectType.OPPORTUNITY_ITEM_STANDARD = 'opportunity_item_standard';
    SalesForceReflectType.OPPORTUNITY_ITEM_PROFESSIONAL = 'opportunity_item_professional';
    SalesForceReflectType.OPPORTUNITY_ITEM_MOTION_AI = 'opportunity_item_motion_ai';
    SalesForceReflectType.OPPORTUNITY_ITEM_ADDITIONAL_TABLET = 'opportunity_item_additional_tablet';
    SalesForceReflectType.OPPORTUNITY_ITEM_ADDITIONAL_TABLET_INITIAL_FEE = 'opportunity_item_additional_tablet_initial_fee';
    SalesForceReflectType.OPPORTUNITY_BASIC_PRE = 'opportunity_basic_pre';
    SalesForceReflectType.OPPORTUNITY_OLD_STANDARD_PRE = 'opportunity_old_standard_pre';
    SalesForceReflectType.OPPORTUNITY_STANDARD_PRE = 'opportunity_standard_pre';
    SalesForceReflectType.OPPORTUNITY_ENTRY_PRE = 'opportunity_entry_pre';
    SalesForceReflectType.OPPORTUNITY_MEDIUM_PRE = 'opportunity_medium_pre';
    SalesForceReflectType.OPPORTUNITY_PROFESSIONAL_PRE = 'opportunity_professional_pre';
    SalesForceReflectType.OPPORTUNITY_UPGRADE_TO_STANDARD_PRE = 'opportunity_upgrade_to_standard_pre';
    SalesForceReflectType.OPPORTUNITY_UPGRADE_PRE = 'opportunity_upgrade_pre';
    SalesForceReflectType.OPPORTUNITY_ADDITIONAL_TABLET_PRE = 'opportunity_additional_tablet_pre';
    SalesForceReflectType.OPPORTUNITY_MOTION_AI_PRE = 'opportunity_motion_ai_pre';
    SalesForceReflectType.OPPORTUNITY_ADDITIONAL_TABLET = 'opportunity_additional_tablet';
    SalesForceReflectType.OPPORTUNITY_BASIC = 'opportunity_basic';
    SalesForceReflectType.OPPORTUNITY_OLD_STANDARD = 'opportunity_old_standard';
    SalesForceReflectType.OPPORTUNITY_STANDARD = 'opportunity_standard';
    SalesForceReflectType.OPPORTUNITY_ENTRY = 'opportunity_entry';
    SalesForceReflectType.OPPORTUNITY_MEDIUM = 'opportunity_medium';
    SalesForceReflectType.OPPORTUNITY_PROFESSIONAL = 'opportunity_professional';
    SalesForceReflectType.OPPORTUNITY_UPGRADE_TO_STANDARD = 'opportunity_upgrade_to_standard';
    SalesForceReflectType.OPPORTUNITY_UPGRADE = 'opportunity_upgrade';
    SalesForceReflectType.OPPORTUNITY_MOTION_AI = 'opportunity_motion_ai';
    SalesForceReflectType.APPLICATION_DETAILS = 'application_details';
    SalesForceReflectType.APPLICATION_DETAILS_PRE = 'application_details_pre';
})(SalesForceReflectType = exports.SalesForceReflectType || (exports.SalesForceReflectType = {}));



//////////////////
// WEBPACK FOOTER
// ./common/src/types/sales_force/ReflectType.ts
// module id = kz7Y
// module chunks = 1